import { render, staticRenderFns } from "./ClassCreateFooter.vue?vue&type=template&id=4df36815&scoped=true&"
import script from "./ClassCreateFooter.vue?vue&type=script&lang=js&"
export * from "./ClassCreateFooter.vue?vue&type=script&lang=js&"
import style0 from "./ClassCreateFooter.vue?vue&type=style&index=0&id=4df36815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df36815",
  null
  
)

export default component.exports